import { render, staticRenderFns } from "./update-content-dialog.vue?vue&type=template&id=5b8f70e0&scoped=true"
import script from "./update-content-dialog.vue?vue&type=script&lang=js"
export * from "./update-content-dialog.vue?vue&type=script&lang=js"
import style0 from "./update-content-dialog.vue?vue&type=style&index=0&id=5b8f70e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f70e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8f70e0')) {
      api.createRecord('5b8f70e0', component.options)
    } else {
      api.reload('5b8f70e0', component.options)
    }
    module.hot.accept("./update-content-dialog.vue?vue&type=template&id=5b8f70e0&scoped=true", function () {
      api.rerender('5b8f70e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/update-content-dialog.vue"
export default component.exports